/**
 * The talk the host just picked from Assets, handed from the entry screen to the
 * board it minted. It lives for the one navigation between them: the board takes
 * it and makes it the room's video.
 */
export interface PickedTalk {
  /** The library asset's id. */
  id: string;
  name: string;
  size: number;
}

const picked = new Map<string, PickedTalk>();

export function handOffTalk(webinarId: string, talk: PickedTalk): void {
  picked.set(webinarId, talk);
}

/** The talk waiting for this board, if the host just picked one. Taken once. */
export function takeTalk(webinarId: string): PickedTalk | null {
  const talk = picked.get(webinarId) ?? null;
  picked.delete(webinarId);
  return talk;
}
